import $ from 'jquery';
//import { fetch } from 'whatwg-fetch';
//import ES6Promise from "es6-promise";

/*******************************************************************************
 *  1. Fetch Util
 *
 *  using fetch instead of ajax.
 *  requires webpack polyfill and whatwg-fetch to operate in any browser that isn't chrome ( this is included in index.html )
 *  Fetch util also will store `fetching`, `fetched`, and `fetchingError` data in the app object of global app state
 */

export default ( opts ) => {

    let url = opts.url;
    let body = { ...opts.body };
	
	let modeName ='';
	
    const requestURL = opts.url;
    const{
        type, method, dispatch,
        onFetching, onFetchingError
    } = opts;

    //assigns 'type: true' to fetching object in app object of global app state
    dispatch( fetching( type ) );

    //assign a function as a value to an onFetching key when using Ajax function to execute a callback here
    onFetching && onFetching();
	
	if(method == 'PUT') {
		modeName = 'cors'
	}else{
		modeName = 'no-cors'
	}
	
    if(
        method !== 'POST' &&
        ( method || FETCH_POST_TYPE ) === 'GET'
    ) {
        if( body ) {
            const query = $.param( body );
            url = url + '?' + query;
        }
        body = null;
    }else{
        body = JSON.stringify( body );
    }

    return fetch(
        url,
        {
            method: method || FETCH_POST_TYPE, //FETCH_POST_TYPE set in config.js
            body: body,
            credentials: 'same-origin',
            mode: 'cors',
            noparse: undefined,
            headers: {
				"Pragma": "no-cache",
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            },
			redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
        }
    )
    .then( ( response ) => {
        if ( process.env.NODE_ENV !== 'test' ) {
            //console.log( response );
        }
        if ( !response.ok ) {
            return Promise.reject( response );
        }

        return response;

    } )
    .then( response => response.json() )
    .then(
        json => {
			let authError;
			let serverError;
			if( json.success == false ) {

				// Adding server error from json object if message object is null adding default error message
				serverError = json.message ? json.message : 'Your Request Could Not Be Processed, please begin again.';

				//assign a function as a value to an onFetchingError key when using Ajax function to execute a callback here
				onFetchingError && onFetchingError( serverError );

				//assigns error data to fetchingError object in global app state app object for specific typ
				dispatch( fetchingServerError( type, serverError, requestURL ) );

			}
			else if( json.authenticated == false ) {

				// Adding authentication error from json object if message object is null adding default error message
				authError = json.message ? json.message : 'Authentication Failed';

				//assign a function as a value to an onFetchingError key when using Ajax function to execute a callback here
				onFetchingError && onFetchingError( authError );

				//assigns error data to fetchingError object in global app state app object for specific typ
				dispatch( fetchingAuthenticationError( type, authError ) );


			}
			else {
				return {
					data: json.data,
					fetched: fetched( type ) //required to set fetched status in global app state app object for specific type
				};
			}

        }
    ).catch(
        response => {
            let error;
            if( response.status && response.statusText ) {
                error = response.status + ': ' + response.statusText;
            }else{
                error = response.stack;
            }

            //assign a function as a value to an onFetchingError key when using Ajax function to execute a callback here
            onFetchingError && onFetchingError( error );

            //assigns error data to fetchingError object in global app state app object for specific typ
            dispatch( fetchingError( type, error ) );

            return Promise.reject( response );
        }
    );
};

/*******************************************************************************
 *  2. Action Types
 */

export const TYPEs = {
    DATA_FETCHING: 'dataFetching',
    DATA_FETCHED: 'dataFetched',
    DATA_FETCHING_ERROR: 'dataFetchingError',
    DATA_RESET_FETCHED: 'dataResetFetched',
	DATA_SERVER_ERROR: 'dataFetchingServerError',
	DATA_AUTHENTICATED_ERROR: 'dataFetchingAuthenticationError'
};

/*******************************************************************************
 *  3. Action Creators
 */

var fetching = ( type ) => {
    return {
        type: TYPEs.DATA_FETCHING,
        fetching: type
    };
};

var fetched = ( type ) => {
    return {
        type: TYPEs.DATA_FETCHED,
        fetched: type
    };
};

var fetchingError = ( type, error ) => {
    return {
        type: TYPEs.DATA_FETCHING_ERROR,
        fetchingError: type,
        error: error
    };
};

var fetchingServerError = ( type, error, url ) => {
    return {
        type: TYPEs.DATA_SERVER_ERROR,
        fetchingError: type,
        error: error,
        url
    };
};

var fetchingAuthenticationError = ( type, error ) => {
    return {
        type: TYPEs.DATA_AUTHENTICATED_ERROR,
        fetchingError: type,
        error: error
    };
};


export var resetFetched = ( type ) => {
    return {
        type: TYPEs.DATA_RESET_FETCHED,
        fetched: type
    };
};



// WEBPACK FOOTER //
// ./src/utils/fetch.js